
const CTABanner = () => {
  return (
    <section className="py-20 bg-primary text-white">
      <div className="container mx-auto px-6">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
          <div className="lg:max-w-2xl">
            <h2 className="font-serif text-4xl md:text-5xl font-bold mb-4">
              Ready to Move? Get Your Free Quote Today
            </h2>
            <p className="text-xl text-white/90">
              Fast, affordable, and reliable bakkie removals and landscaping services across KwaZulu-Natal
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 lg:flex-shrink-0">
            <a
              href="https://wa.me/27798768956"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white text-primary px-10 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-all hover:scale-105 inline-flex items-center justify-center whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line mr-3 text-2xl w-6 h-6 flex items-center justify-center"></i>
              WhatsApp Us Now
            </a>
            <a
              href="tel:+27798768956"
              className="bg-transparent border-2 border-white text-white px-10 py-4 rounded-full font-bold text-lg hover:bg-white hover:text-primary transition-all inline-flex items-center justify-center whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-3 text-2xl w-6 h-6 flex items-center justify-center"></i>
              079 876 8956
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
